import type { UnitInfoGenericCrusherInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { GenericCrusherMapInterface } from './GenericCrusherTypes';
import { GenericCrusherTypes } from './GenericCrusherTypes';
import { getDefaultHighBinData } from '../../Crushers/CrusherConeCH/CrusherConeCHData';

export const GenericCrusherData: GenericCrusherMapInterface = {
  [GenericCrusherTypes.GYRATORY_CRUSHER]: {},
  [GenericCrusherTypes.JAW_CRUSHER]: {},
  [GenericCrusherTypes.CONE_CRUSHER]: {},
  [GenericCrusherTypes.VSI]: {},
  [GenericCrusherTypes.HSI]: {},
  [GenericCrusherTypes.HYBRID]: {},
  [GenericCrusherTypes.SAG_MILL]: {},
  [GenericCrusherTypes.AG_MILL]: {},
  [GenericCrusherTypes.BALL_MILL]: {},
  [GenericCrusherTypes.ROD_MILL]: {},
  [GenericCrusherTypes.HPGR]: {},
};

export class GenericCrusherConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoGenericCrusherInterface {
    return {
      modelName: GenericCrusherTypes.CONE_CRUSHER,
      ...BaseUnitConfig.getBaseDefaults(),
      psdName: 'Custom',
      percent: [0],
      size: [0],
      curveEditIndex: undefined,

      materialOptions: [],
      hidePsd: false,
      showCustomModel: true,
      highBin: getDefaultHighBinData(),

      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayDescription: true,
        displayPsdList: false,
        displayPsdGraph: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const genericCrusherConfig = new GenericCrusherConfig();
